import React from "react";
import Chart from "react-google-charts";
export default function InstructorDashbordCard({
  title,
  result,
  resultSince,
  graphReport,
  dataCard,
  graphLineColor
}) {
  const data = [
    ["x", "dogs"],
    [0, 0],
    [1, 10],
    [2, 23],
    [3, 17],
    [4, 18],
    [5, 9],
    [6, 11],
    [7, 27],
    [8, 33],
    [9, 40],
    [10, 32],
    [11, 35],
  ];

  const options = {
    legend: "none",
    backgroundColor: "transparent",
    hAxis: {
      textPosition: "none",
      gridlines: { color: "transparent" },
      baselineColor: "transparent",
    },
    vAxis: {
      textPosition: "none",
      gridlines: { color: "transparent" },
      baselineColor: "transparent",
    },
    lineWidth: 2,
    colors: [graphLineColor],
    enableInteractivity: false,
    areaOpacity: 0.2,
    chartArea: { width: "100%", height: "100%" },
  };

  return (
    <div className="col-12 col-sm-6 col-lg-3 mb-30">
      <div
        className={`instructor-dashboard-card result-card card-animate students-card`}
        data-card={dataCard}
      >
        <h3 className="ah-text-md mb-10 fw-semibold">{title}</h3>
        <div className="ah-heading-03 fw-semibold mb-28">{result || "0"}</div>
        <div className="footer">
          <div>
            <p className="ah-text-xs fw-semibold">{resultSince}</p>
            <span className="badge py-6 px-8 ah-text-xs fw-normal">
              {graphReport}
            </span>
          </div>
          <Chart
            chartType="AreaChart"
            width="150px"
            height="75px"
            data={data}
            options={options}
          />
        </div>
      </div>
    </div>
  );
}
